import React, { useEffect, useState } from "react";
import PageHeader from "@atlaskit/page-header";
import AdminLayout from "../../layouts/admin-layout";
import apiClient from "../../api/admin-api-client";
import { toast } from "react-toastify";
import ButtonGroup from "@atlaskit/button/button-group";
import Button from "@atlaskit/button/custom-theme-button";
import useAsync from "../../hooks/use-async";
import useAdminWorkflows from "../../hooks/use-admin-workflows-list";
import { useTranslation } from "react-i18next";
import DynamicTable from "@atlaskit/dynamic-table";
import DropdownMenu, { DropdownItem, DropdownItemGroup } from "@atlaskit/dropdown-menu";
import RemoveWorkflow from "../../components/workflows/remove-workflow";
import CreateWorkflow from "../../components/workflows/create-workflow";
import EditWorkflow from "../../components/workflows/edit-workflow";

function AdminWorkflows() {
    const { t } = useTranslation();
    const [ formOpen, setAddFormOpen ] = useState(false);
    const [ workflowToRemove, setWorkflowToRemove ] = useState(null);
    const [ workflowToEdit, setWorkflowToEdit ] = useState(null);
    const { workflows, isPending, reload } = useAdminWorkflows();

    const actionsContent = (
        <ButtonGroup>
            <Button appearance="primary" onClick={() => setAddFormOpen(true)}>
                {t("admin_workflows_new")}
            </Button>
        </ButtonGroup >
    );

    const head = {
        cells: [
            { key: "id", content: t("admin_workflows_column_id"), isSortable: false, width: "50px" },
            { key: "name", content: t("admin_workflows_column_name"), isSortable: false },
            { key: "worker", content: t("admin_workflows_column_worker"), isSortable: false },
            { key: "actions", content: null, isSortable: false, align: "right", width: "50px" },
        ]
    };

    const rows = workflows?.map(workflow => ({
        key: workflow.name,
        cells: [
            { key: "id", content: <p>{workflow.id}</p> },
            { key: "name", content: <p>{workflow.name}</p> },
            { key: "worker", content: <p>{workflow.worker}</p> },
            { key: "actions", content: <DropdownMenu  position="bottom right" triggerType="button">
                <DropdownItemGroup>
                    <DropdownItem onClick={() => setWorkflowToEdit(workflow)}>
                        {t("admin_workflows_edit")}
                    </DropdownItem>
                    <DropdownItem onClick={() => setWorkflowToRemove(workflow)}>
                        {t("admin_workflows_remove")}
                    </DropdownItem>
                </DropdownItemGroup>
            </DropdownMenu>
            }
        ]
    }));

    return <AdminLayout>
        <PageHeader actions={actionsContent}>
            {t("admin_workflows_heading")}
        </PageHeader>
        <DynamicTable
            head={head} 
            rows={rows}
            loadingSpinnerSize="large"
            isLoading={isPending}
        />
        {workflowToRemove && <RemoveWorkflow 
            workflow={workflowToRemove} 
            onRemoved={() => {
                setWorkflowToRemove(null);
                reload();
            }} onClose={() => {
                setWorkflowToRemove(null);
            }} />}
        {workflowToEdit && <EditWorkflow 
            workflow={workflowToEdit} 
            onUpdated={() => {
                setWorkflowToEdit(null);
                reload();
            }} onClose={() => {
                setWorkflowToEdit(null);
            }} />}
        {formOpen && <CreateWorkflow
            onClose={() => setAddFormOpen(false)}
            onAdded={() => {
                setAddFormOpen(false);
                reload();
            }}
        />}
    </AdminLayout>;
}

export default AdminWorkflows;
